import initFunnel from './components/funnel';

document.querySelectorAll<HTMLElement>('.funnel-page-block').forEach(funnel => initFunnel(funnel));
